import { setStep01 } from './Step01';
import { lookupBusinessName } from './searchCompany';

export const searchCompanyByName = (name, callback = setStep01) => {
  return (dispatch) => {
    if (name === '') {
      dispatch(callback({ businesses: [] }));
      return;
    }
    dispatch(callback({ loading: true }));
    return lookupBusinessName(name)
      .then((businesses) => {
        let saveData = {
          businesses
        };
        dispatch(callback(saveData));
        return businesses;
      })
      .catch((err) => {
        if (err.message === 'Operation canceled by the user.') {
          return;
        }
        throw err;
      })
      .finally(() => {
        dispatch(callback({ loading: false }));
      });
  };
};
